import { createContext, useContext } from 'react'

export interface PageHeaderSlotContextValue {
  /** True once the page's title/breadcrumb has scrolled out of view. */
  pinned: boolean
  setPinned: (pinned: boolean) => void
  /** The scrollable `<main>` element — used as the IntersectionObserver root. */
  mainNode: HTMLElement | null
  /** Always-mounted bar slot the breadcrumb portals into. */
  barLeftNode: HTMLElement | null
  /** Always-mounted bar slot the pinned title + actions portal into. */
  barPinnedNode: HTMLElement | null
}

const defaultValue: PageHeaderSlotContextValue = {
  pinned: false,
  setPinned: () => {},
  mainNode: null,
  barLeftNode: null,
  barPinnedNode: null,
}

export const PageHeaderSlotContext = createContext<PageHeaderSlotContextValue>(defaultValue)

export function usePageHeaderSlot() {
  return useContext(PageHeaderSlotContext)
}
